import React from "react";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { decimalFormatter } from "../../../Utils/Formatter";
import Card from "../../../Components/Card";
import moment from "moment";

const OsSystemStackedBarChart = ({
  data,
  showTooltipTotal,
  showTooltipPercent,
  tooltipUnit,
}) => {
  const sortedData = data
    .map((acft) => {
      return {
        ...acft,
        android: acft.android ? parseInt(acft.android) : 0,
        ios: acft.ios ? parseInt(acft.ios) : 0,
        linux: acft.linux ? parseInt(acft.linux) : 0,
        macos: acft.macos ? parseInt(acft.macos) : 0,
        win64: acft.win64 ? parseInt(acft.win64) : 0,
        switch: acft.switch ? parseInt(acft.switch) : 0,

        total:
          parseInt(acft?.android ?? 0) +
          parseInt(acft?.ios ?? 0) +
          parseInt(acft?.linux ?? 0) +
          parseInt(acft?.macos ?? 0) +
          parseInt(acft?.switch ?? 0) +
          parseInt(acft?.win64 ?? 0),
      };
    })
    .sort((a, b) => b.sum - a.sum);
  return (
    <ResponsiveContainer height={300}>
      <ComposedChart
        syncId={"user_analytics"}
        data={sortedData ?? []}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="day" />
        <YAxis />
        <Tooltip
          content={
            <CustomTooltip
              showTooltipPercent={showTooltipPercent}
              showTooltipTotal={showTooltipTotal}
              tooltipUnit={tooltipUnit}
            />
          }
        />
        <Legend />
        <Bar dataKey="ios" stackId="a" fill="#A87BCC" />
        <Bar dataKey="android" stackId="a" fill="#9FCC7B" />
        <Bar dataKey="win64" stackId="a" fill="#064CC4" />
        <Bar dataKey="macos" stackId="a" fill="#3b82f6" />
        <Bar dataKey="linux" stackId="a" fill="#06b6d4" />
        <Bar dataKey="switch" stackId="a" fill="#F74251" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

const CustomTooltip = ({
  active,
  payload,
  label,
  showTooltipPercent,
  showTooltipTotal,
  tooltipUnit,
}) => {
  if (active && payload && payload.length) {
    return (
      <Card>
        <p className="text-xs font-bold mb-2">
          {moment(label).format("ddd, MMMM Do YYYY")}
        </p>
        {payload
          ?.sort((a, b) => a.value > b.value)
          ?.map((item, index) => (
            <div
              key={item.name}
              className="grid grid-cols-12 text-sm"
              style={{ color: item.color ?? item.fill }}
            >
              <p className="col-span-6 border-t border-gray-200">{item.name}</p>

              <p className="col-span-4 border-t border-gray-200 text-right px-2">
                {decimalFormatter.format(item.value) +
                  (tooltipUnit ? " " + tooltipUnit : "")}{" "}
              </p>
              {showTooltipPercent && (
                <p className=" col-span-2 border-t border-gray-200 text-right">
                  {item.value > 0
                    ? (
                        (item.value /
                          payload.reduce((acc, curr) => acc + curr.value, 0)) *
                        100
                      ).toFixed(0) + "%"
                    : ""}
                </p>
              )}
            </div>
          ))}
        {showTooltipTotal && (
          <div className="grid grid-cols-12 text-sm ">
            <p className="col-span-6 border-t border-gray-400 font-bold ">
              {"total"}
            </p>
            <p className="col-span-4 border-t border-gray-400 font-bold text-right px-2">
              {decimalFormatter.format(
                payload.reduce((acc, curr) => acc + curr.value, 0)
              )}
            </p>
            <p className=" col-span-2 border-t border-gray-400 "></p>
          </div>
        )}
      </Card>
    );
  }

  return null;
};
export default OsSystemStackedBarChart;
